export const handleQueryStrings = () => {
    const fullUrl = window.location.href;

    let showSavings = true;
    if (fullUrl.includes('/no-savings')) {
        showSavings = false;
    }

    const query = new URLSearchParams(window.location.search);

    const ppcid = query.get("ppcid") || '7';
    const cid = query.get("cid") || 'RateZip';

    return { showSavings, ppcid, cid };
}